import {createSlice} from "@reduxjs/toolkit";


export const BaseSlice = createSlice({
    name: "base",
    initialState: {
        topAppbarContents: null,
        topAppbarHeight: -1,
        leftAppbarWidth: 80,
        rightAppbarWidth: 80,
        contentDivHeight: 0,
        paperHeight: 0,
        openTopDrawer: false,
        showBars: true,
        latestDate: ''
    },
    reducers: {
        setShowBar:(state, action)=>{
            state.showBars = action.payload
        },
        setOpenTopDrawer: (state, action) => {
            state.openTopDrawer = action.payload
        },
        setTopAppbarHeight: (state, action) => {
            state.topAppbarHeight = action.payload
        },
        setLeftAppbarWidth: (state, action) => {
            state.leftAppbarWidth = action.payload
        },
        setContentDivHeight: (state, action) => {
            state.contentDivHeight = action.payload;
            state.paperHeight = action.payload - 30;
        },
        setPaperHeight: (state, action) => {
            state.paperHeight = action.payload
        },
        setTopAppbarContents: (state, action) => {
            state.topAppbarContents = action.payload
        },
        setLatestDate: (state, action) =>{
            state.latestDate = action.payload
        }
    }
});

export const baseActions = BaseSlice.actions;
export const baseReducer = BaseSlice.reducer;
